import { useTranslations } from "next-intl";

import { FormControl, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";


interface IAmountProps extends React.ComponentProps<"input"> {
    isPending: boolean;
}

export const Amount = ({ isPending, ...props }: IAmountProps) => {
    const t = useTranslations("expense");

    return (
        <FormItem className="flex flex-col items-center justify-between md:flex-row">
            <FormLabel className="text-lg">{t("amount")} :</FormLabel>
            <div className="w-full md:w-1/2">
                <FormControl>
                    <Input { ...props } disabled={ isPending } type="number" min="0" step="0.01" />
                </FormControl>
                <FormMessage />
            </div>
        </FormItem>
    );
};